import React from 'react';
import SectionWithBanner from 'components/commercetools-ui/atoms/section-with-banner';
import dynamic from 'next/dynamic';

const Markdown = dynamic(() => import('components/commercetools-ui/organisms/markdown'));

export interface ContentWithBannerCMSProps {
  data: any;
}

const ContentWithBannerCMS: React.FC<ContentWithBannerCMSProps> = ({ data }) => {
  return (
    <>
      <div className="flex flex-col w-full">
        {data?.data?.dataSource?.sections?.map((component: any, index: number) => {
          return (
            <div key={index}>
              {component?.section_with_banner && (
                <div className="padding-t-2xl-66 padding-t-xl-68 padding-t-32">
                  <SectionWithBanner data={component?.section_with_banner} />
                </div>
              )}

              {component?.section_with_heading_description && (
                <div className={`${index === 3 ? 'padding-b-80' : ''}`}>
                  <div>
                    <div
                      className={`w-min-100-41 ${
                        index === 1
                          ? 'fontSize40-2xl fontSize30-xl font-size24-sm'
                          : 'fs-4 padding-t-40 padding-t-2xl-80'
                      } title font-medium lineHeight40 border-none-lg padding-b-12 m-auto text-primary-black`}
                    >
                      {component?.section_with_heading_description?.title}
                    </div>
                    <Markdown
                      className={`${
                        index === 1 &&
                        component?.section_with_heading_description?.description.includes('<img')
                          ? 'w-min-100-41 m-auto'
                          : ''
                      } mardown-container content-markdown-container font-weight-normal
                        fontSize14-sm fontSize16-md fontSize18-2xl`}
                      markdown={component.section_with_heading_description?.description}
                    />
                  </div>
                  {/* Inline CSS for ul and li .. */}
                  <style>{`
                    @media (min-width: 320px) and (max-width: 768px){
                      .mardown-container ul {
                        margin-left: 2rem !important;
                      }
                      .mardown-container li {
                        list-style: disc !important;
                        
                      }
                    }
                    .content-markdown-container>ul {
                      width: min(100%, 40rem);
                    }
                  `}</style>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ContentWithBannerCMS;
